import { Actions, ActionType, State } from './types';

const initialState: State = {
  isActive: false,
  currentStepIndex: 0,
};

const reducer = (state: State = initialState, action: Actions) => {
  switch (action.type) {
    case ActionType.startGuidedMode:
      return {
        ...state,
        isActive: true,
        currentStepIndex: 0,
      };
    case ActionType.goToGuidedStep:
      return {
        ...state,
        currentStepIndex: Math.max(0, action.stepIndex),
      };
    case ActionType.nextGuidedStep:
      return {
        ...state,
        currentStepIndex: state.currentStepIndex + 1,
      };
    case ActionType.previousGuidedStep:
      return {
        ...state,
        currentStepIndex: Math.max(0, state.currentStepIndex - 1),
      };
    case ActionType.finishGuidedMode:
    case ActionType.cancelGuidedMode:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
